import { DateService } from "../../services/date.service";
import { RenderColumn } from "../../types/column.types";
import { Sms } from '../../types/sms.types';

export const DateSmsColumn: RenderColumn<Sms> = (_, sms) =>
  DateService.getFullDate(sms.created_at);
